import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TemaService {
  private httpPublicClient: HttpClient;

  constructor(
    private httpClient: HttpClient,
    private HttpBackend: HttpBackend
  ) {
    this.httpPublicClient = new HttpClient(HttpBackend);
  }

  getTemasActivosByBurbuja(burbujaId: number) {
    return this.httpClient.get(
      encodeURI(
        `${environment.apiURL}/temas/activosByBurbuja?burbujaId=${burbujaId}`
      )
    );
  }

  getTemasActivosByBurbujaPublic(burbujaId: number) {
    return this.httpPublicClient.get(
      encodeURI(
        `${environment.apiURL}/public/temasByBurbuja?burbujaId=${burbujaId}`
      )
    );
  }

  getTemaBurbujaByTema(temaId: number) {
    return this.httpClient.get(
      encodeURI(
        `${environment.apiURL}/temas/temasBurbujasByTema?temaId=${temaId}`
      )
    );
  }

  getTemaBurbujaByTemaPublic(temaId: number) {
    return this.httpPublicClient.get(
      encodeURI(
        `${environment.apiURL}/public/temasBurbujasByTema?temaId=${temaId}`
      )
    );
  }

  crearTema(tema: { descripcion: string; burbuja: string }) {
    const formData = new FormData();
    formData.append('descripcion', tema.descripcion);
    formData.append('burbujaId', tema.burbuja);

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/temas`),
      formData
    );
  }

  modificarTema(
    temaId: string,
    tema: {
      descripcion: string;
      burbuja: string;
    }
  ) {
    const formData = new FormData();
    formData.append('descripcion', tema.descripcion.trim());
    formData.append('burbujaId', tema.burbuja);

    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/temas/${temaId}`),
      formData
    );
  }

  cambiarOrden(temas: any) {
    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/temas/cambiarOrden`),
      temas
    );
  }

  eliminarTema(temaId: number) {
    return this.httpClient.delete(
      encodeURI(`${environment.apiURL}/temas/${temaId}`)
    );
  }

  contarPreguntas(temaId: number) {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/temas/countPreguntas/${temaId}`)
    );
  }

  getTemasBurbujas() {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/temas/temasBurbujas`)
    );
  }
}
